var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmergencyLamp201({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "13.7,13.41 8,7.79 2.27,13.53  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1.97,13.66L8,7.61l6,5.92L1.97,13.66z M8,7.97L2.58,13.4l10.82-0.12L8,7.97z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "13.73,2.47 8.02,7.95 2.32,2.58  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.02,8.12L2.01,2.46l12.03-0.12L8.02,8.12z M2.63,2.7l5.38,5.07l5.4-5.18L2.63,2.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyLamp201);
export default __webpack_public_path__ + "static/media/EmergencyLamp2-01.e00f6e9f81e26fd3c0cd279f27f0f6f7.svg";
export { ForwardRef as ReactComponent };